import { render } from "./AppBreadcrumb.vue?vue&type=template&id=4ee89c13&ts=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/lk/Documents/SecondCorner/programs/sc_backend_v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__